import { createFileRoute } from '@tanstack/react-router'
import { healthQueryOptions, noticeSearchSchema } from '../../src/schemas/routeSchemas'

export const Route = createFileRoute('/notice')({
  validateSearch: (search) => noticeSearchSchema.parse(search),
  loaderDeps: () => ({}),
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData(healthQueryOptions)
  },
  staticData: {
    englishAllowed: true,
    layout: 'menu',
  },
})
